import './App.css';
import Home from './home/home';

function App() {
  return (
    <Home />
  );
}

export default App;
